import { z } from 'zod';

type EmailValidationOptions = {
  required?: boolean;
  requiredMessage?: string;
  invalidMessage?: string;
};

export const validateEmail = (
  value: string | null | undefined,
  {
    required = false,
    requiredMessage = 'Email is required',
    invalidMessage = 'Please enter a valid email address',
  }: EmailValidationOptions = {}
) => {
  const trimmed = value?.trim() ?? '';

  if (!trimmed) {
    return required ? requiredMessage : true;
  }

  const result = z
    .string()
    .trim()
    .email({ message: invalidMessage })
    .safeParse(trimmed);

  return result.success ? true : invalidMessage;
};
